export default __webpack_public_path__ + "static/media/gallery-img-5.1077364d.jpg";